import React from 'react';
import PropTypes from 'prop-types';
import { ImageLazyLoad } from '../../';
import './styles.scss';

const propTypes = {
  snapshot: PropTypes.object,
};

// @todo: convert to presentation component

class BlogPostResult extends React.Component {

  render() {
    const { snapshot } = this.props;
    let loaderProps = { style: { height:190 }, dark: true }
    return (
      <a href={snapshot.snapshots_url.replace('http://', 'https://')} target="_blank" className="col-md-4 search-result-item snapshot-result">
        <div className="snapshot-inner-wrap">
          <div className="snapshot-hover-info"><div className="u-font-foundation-light abs-center hover-text">View <br />Snapshot</div></div>
          <ImageLazyLoad src={snapshot.thumbnail_url} loaderProps={loaderProps} minHeight={124} />
        </div>
      </a>
    )
  }
}

BlogPostResult.propTypes = propTypes;

export default BlogPostResult;
